'use client';

import { __makeTemplateObject } from '../../../_virtual/_tslib.js';
import styled from 'styled-components';

var ToolTipWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    z-index: 1;\n    background: #fff;\n    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);\n    border-radius: 4px;\n    transition: all 0.25s ease-in-out;\n    pointer-events: none;\n    padding: 8px;\n"], ["\n    position: absolute;\n    z-index: 1;\n    background: #fff;\n    box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);\n    border-radius: 4px;\n    transition: all 0.25s ease-in-out;\n    pointer-events: none;\n    padding: 8px;\n"])));
var templateObject_1;

export { ToolTipWrapper };
//# sourceMappingURL=Tooltip.css.js.map
